import { useState } from 'react';
import ContactForm from './ContactForm';
import LoadReviews from './LoadReviews';
import ReviewsListing from './ReviewsListing';
import TellUsMoreForm from './TellUsMoreForm';
import AuditReady from './AuditReady';
import { WizardData, UpdateStepWithData } from '../types';

const Wizard = () => {
  const [activeStep, setStep] = useState(0);
  const [data, setData] = useState({} as WizardData);

  const updateStepWithData: UpdateStepWithData = (stepData, stepIndex) => {
    setData({ ...data, ...stepData });
    setStep(stepIndex);
  };

  const updateStep = (stepIndex: number) => () => setStep(stepIndex);

  switch (activeStep) {
    case 0:
      return <ContactForm onNext={updateStepWithData} />;
    case 1:
      return <LoadReviews jobId={data.jobId} onNext={updateStepWithData} />;
    case 2:
      return (
        <ReviewsListing
          auditSources={data.auditSources}
          onNext={updateStep(3)}
          onRetry={updateStep(0)}
        />
      );
    case 3:
      return <TellUsMoreForm jobId={data.jobId} onNext={updateStepWithData} />;
    case 4:
      return <AuditReady leadToken={data.leadToken} />;
  }
};

export default Wizard;
